export default function Fonts() {
  return (
    <div className="p-4">
      <h1>Fonts</h1>
    </div>
  );
}
